<template>
<div class="page-guide _brand">

    <h1 class="heading_section-title">
        <p class="main">SHOWROOM GUIDE</p>
        <span>ショールームご利用ガイド</span>
    </h1>

    <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::
        FAQ
    :::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
    <section class="faq">
        <div class="inner">

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>新規登録</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            <h3 class="nest-item__title">ご用意するもの</h3>
                            ・メールアドレス<br>
                            あなたのメールアドレスを記載します。<br>
                            弊社からのお知らせや、お客様からの問い合わせがあったときにメールが届くアドレスです。<br><br>

                            ・写真（5M以下）トリミング可能　2枚<br>
                            ショールームの詳細画像　4枚<br>
                            写真のクオリティーをとても大切にしています。ブランドイメージがわかるような画像をご用意ください。<br><br>
                            <img src="/img/page-about/showroom/showroom01.jpg" alt="">
                        </div>

                        <!-- NestItem -->
                        <div class="nest-item">
                            <h3 class="nest-item__title"> 情報を入力後メールを送信</h3>
                            <img src="/img/page-about/shop/shop11.jpg" alt="">
                        </div>

                        <!-- NestItem -->
                        <div class="nest-item">
                            <h3 class="nest-item__title">AUMAよりメールを受信</h3>
                            メールが受信できない場合は<br>
                            ・認証メール再送信をクリックし再送信をお試しください。<br>
                            ・メーラーの迷惑メールのフォルダをお確認してください。
                        </div>

                        <!-- NestItem -->
                        <div class="nest-item">
                            <h3 class="nest-item__title">仮設置登録</h3>
                            ① ショールーム名<br><br>
                            ② ショールーム名ふりがな<br><br>
                            ③ ショールームの画像2枚<br>
                            　ショールームの詳細画像　4枚<br><br>
                            ④ ショールームのコンセプト<br>
                            ※あなたのショールームのイメージやジャンルなどを教えてください。<br><br>
                            ⑤ セールスブランドインフォ<br>
                            ・AUMAに登録したブランド（BASIC)をショールームで紐つけるとここに表示されます。（複数入力可能）<br>
                            ・その他の取扱いブランド<br>
                            AUMAに無料登録、もしくは登録していないブランドを教えて下さい。<br>
                            ・展示会・POPUP情報<br>
                            ショールームが行う展示会やPOPUPなどのイベント情報を教えて下さい。<br>
                            ・MOVIE<br>
                            ショールームまたはブランドのムービーを登録して下さい。
                            ※動画はYouTubeのURLを使用して下さい。<br><br>
                            ⑥ ブランドのコンセプト<br>
                            ※あなたのブランドのイメージやジャンルなどを教えてください。<br><br>
                            ⑦ ブランドの情報<br>
                            ・カテゴリ<br>
                                ショールームが展開する商品のカテゴリを選択してください。<br>
                                （複数入力可能）<br>
                            ・プライス<br>
                                商品の金額平均を入力<br>
                            ・ターゲット<br>
                                ショールーム・ブランドのターゲットの年齢層を選択してください。<br>
                            ・オンライン/WEB<br>
                                WEBサイトやECサイトがあれば入力してください。<br>
                            ・対象店舗<br>
                                実店舗・ECサイト両方可、実店舗のみ可、ECサイトのみ可、POPUPのみ可または、卸無しから選択してください。<br>
                                WEBサイトやECサイトがあれば入力してください。<br><br>
                            ⑥ SNSアカウント
                                <img src="/img/page-about/showroom/showroom02.jpg" alt="">
                        </div>

                        <!-- NestItem -->
                        <div class="nest-item">
                            <h3 class="nest-item__title">価格評価判定</h3>
                            AUMA内での価格評価判定を行います。<br>
                            ブランドで取り扱っている商品の価格帯で、AUMA内でのセグメントが決まります。<br>
                            ※データに基づいて、自社の製品やサービスにあったターゲットを絞り検索しやすくする為。<br><br>

                            STEP01 取り扱い商品のジャンル登録<br>
                            ブランドで取り扱いがある商品のジャンルの中から、3つまで選択してください。<br>
                            ※表示される商品はブランドページで選択された項目が表示されています。<br><br>

                            STEP02 取り扱い商品種類を登録<br>
                            STEP01で登録した取り扱い商品の種類を選択してください。<br><br>

                            STEP03 商品の平均の価格帯を教えてください。<br><br>

                            審査登録するを押下
                            <img src="/img/page-about/shop/shop04.jpg" alt="">
                            <img src="/img/page-about/shop/shop05.jpg" alt="">
                            <img src="/img/page-about/shop/shop06.jpg" alt="">
                            <img src="/img/page-about/shop/shop07.jpg" alt="">
                        </div>

                        <!-- NestItem -->
                        <div class="nest-item">
                            <h3 class="nest-item__title">審査登録が完了</h3>
                            運営審査後、メールにてログイン情報をお送りいたします。
                            <img src="/img/page-about/shop/shop08.jpg" alt="">
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ショールーム管理画面</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            <h3 class="nest-item__title">管理画面へのログイン</h3>
                            メールアドレスとパスワードを入力し、【ログインボタン】を押します。<br>
                            ※ログイン情報を保存するにチェックを入れると次回のログイン時にユーザーネームとパスワードの入力を省略できます。
                            <img src="/img/page-about/shop/shop14.jpg" alt="">
                        </div>

                        <!-- NestItem -->
                        <div class="nest-item">
                            <h3 class="nest-item__title"> 各メニューの説明</h3>
                            ・News<br>
                            ブランドからの返信や、運営からのお知らせをいたします。<br><br>
                            ・DM一覧<br>
                            アプローチのDM一覧と編集を行えます。<br><br>
                            ・ShowRoom<br>
                            ステータス（公開・非公開）の変更や現在の価格軸を確認できます。<br><br>
                            ・Sales Brands Info<br>
                            ショールームに追加したブランド情報の確認が出来ます。<br><br>
                            ・shop<br>
                            AUMAトークで連絡の来たショップへ受信と返信が行えます。<br><br>
                            ・Brand<br>
                            AUMAトークで連絡の来たブランドへ受信と返信が行えます。<br><br>
                            ・setting<br>
                            ユーザーの情報や通知設定、ログインパスワードの変更ができます。
                            <img src="/img/page-about/showroom/showroom03.jpg" alt="">
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ブランドを探す</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            <h3 class="nest-item__title">トップページのブランド一覧にはAUMAに登録されているブランドが、ランダムに表示されクリックするとブランドの詳細情報が表示されます。</h3>
                            <img src="/img/page-about/shop/shop16.jpg" alt="">
                        </div>

                        <!-- NestItem -->
                        <div class="nest-item">
                            <h3 class="nest-item__title">虫眼鏡のアイコンからブランド検索が可能です。</h3>
                            ・価格軸検索<br>
                            Standard、Highclass、Luxuryの価格軸で検索を行うことが可能です。<br><br>
                            ・カテゴリー検索<br>
                            Apparel、Life Style、Food、Beauty&Healthのカテゴリーで検索が可能です。<br><br>
                            ・こだわり条件検索<br>
                            ターゲット<br>
                            ターゲットの年齢層で検索が可能です。<br><br>
                            対象店舗<br>
                            対象店舗の可・不可で検索が可能です。<br><br>
                            プライス<br>
                            価格帯での検索が可能です。<br><br>
                            ・保存した検索条件<br>
                            検索後、検索した内容を保存でき、再度その内容で検索が可能です。<br><br>
                            ・フリーワード検索<br>
                            フリーワードでの検索が可能です
                            <img src="/img/page-about/shop/shop17.jpg" alt="">
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </section>

    <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::
        CTA
    :::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
    <section class="md_cta ">
        <div class="body">
            <h2 class="title">AUMAで新たな取引先を見つけてみませんか？</h2>
            <p>初期費用や月額料は一切かかりません。さっそくAUMAを利用しましょう！※</p>
            <div class="link">
                <div class="btn_link-wrap">
                    <a v-bind:href="route('registration.top')" class="btn_link"><span>無料でAUMAを試してみる</span></a>
                    <div class="bg-element"></div>
                </div>
            </div>
        </div>
        <p>※BASICプランへのアップグレードあり</p>
        <div class="background-image">
            <img src="/img/page-about/about-cta.jpg" alt="">
        </div>
    </section>

</div>
</template>

<style>
.md_accordion-item .nest-item {
    counter-reset: number 0;
}
</style>

<script>
    import EndUserLayout from '@/Layouts/EndUserLayout'

    //ScrollTrigger
    import gsap from 'gsap';
    import { ScrollTrigger } from "gsap/ScrollTrigger";
    gsap.registerPlugin(ScrollTrigger);

    //Svg
    import SvgLogoAuma from '@/components/EndUser/svg/SvgLogoAuma'

    export default {
        layout: EndUserLayout,
        components: {
            SvgLogoAuma,
        },
        mounted() {
            ////////////////////////////////////
            //フローチャートの背景文字
            ////////////////////////////////////
            //固定 -----------------------------
            gsap.to("section.flowchart .bg-element-wrap", {
                scrollTrigger: {
                    trigger: "section.flowchart .bg-element-wrap",
                    start: "top 0%",
                    endTrigger: "section.plan-select",
                    end: "top 100%",
                    pin: true,
                    pinSpacing: false,
                },
            });
            gsap.fromTo("section.flowchart .bg-element span._top", {
                autoAlpha: 0,
                xPercent: -10,
            },
            {
                scrollTrigger: {
                    trigger: "section.flowchart",
                    start: "top 100%",
                    end: 'bottom 0%',
                    toggleActions: 'play play resume reverse',
                    scrub: 1,
                },
                autoAlpha: 1,
                xPercent: 0,
            });
            gsap.fromTo("section.flowchart .bg-element span._bottom", {
                autoAlpha: 0,
                xPercent: 10,
            },
            {
                scrollTrigger: {
                    trigger: "section.flowchart",
                    start: "top 100%",
                    end: 'bottom 0%',
                    toggleActions: 'play play resume reverse',
                    scrub: 1,
                },
                autoAlpha: 1,
                xPercent: 0,
            });

            ////////////////////////////////////
            //画像のパララックス
            ////////////////////////////////////
            gsap.to(".features .item-wrap._no1 .img-wrap img", {
                scrollTrigger: {
                    trigger: ".features .item-wrap._no1 .img-wrap img",
                    start: "top 100%",
                    end: 'bottom 0%',
                    toggleActions: 'play play resume reverse',
                    scrub: 0.5,
                },
                yPercent: -15, //transform の translateY(n%) と同一。
            });
            gsap.to(".features .item-wrap._no2 .img-wrap img", {
                scrollTrigger: {
                    trigger: ".features .item-wrap._no2 .img-wrap img",
                    start: "top 100%",
                    end: 'bottom 0%',
                    toggleActions: 'play play resume reverse',
                    scrub: 0.5,
                },
                yPercent: -15, //transform の translateY(n%) と同一。
            });
            gsap.to(".features .item-wrap._no3 .img-wrap img", {
                scrollTrigger: {
                    trigger: ".features .item-wrap._no3 .img-wrap img",
                    start: "top 100%",
                    end: 'bottom 0%',
                    toggleActions: 'play play resume reverse',
                    scrub: 0.5,
                },
                yPercent: -15, //transform の translateY(n%) と同一。
            });
            gsap.to(".features .item-wrap._no4 .img-wrap img", {
                scrollTrigger: {
                    trigger: ".features .item-wrap._no4 .img-wrap img",
                    start: "top 100%",
                    end: 'bottom 0%',
                    toggleActions: 'play play resume reverse',
                    scrub: 0.5,
                },
                yPercent: -15, //transform の translateY(n%) と同一。
            });

            ////////////////////////////////////
            //TimeLine
            ////////////////////////////////////
            gsap.fromTo(".md_timeline .progress-bar .bar", {
                scaleY: 0.08,
                ease: "none",
            },
            {
                scrollTrigger: {
                    trigger: ".md_timeline",
                    start: "top 80%",
                    end: 'bottom 45%',
                    toggleActions: 'play play resume reverse',
                    scrub: 0.2,
                },
                scaleY: 1,
            });

        }//mounted
    }
</script>
